import React, {Component} from 'react';
import axios from 'axios';
import cookie from 'react-cookies';
import {Redirect} from 'react-router';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Navigation from './Navigation';
import Header from './Header';
import Footer from './Footer';
import AddAsset from './AddAsset';
import AddCharacter from './AddCharacter';
import Modal from "react-bootstrap/Modal";
import 'bootstrap/dist/css/bootstrap.min.css';

import '../App.css';

import Chinese from '../translations/cn';
import English from '../translations/en';
import Japanese from '../translations/jp';
import Korean from '../translations/ko';
import German from '../translations/ge';
import French from '../translations/fr';
import Spanish from '../translations/sp';
import Italian from '../translations/it';
import Russian from '../translations/ru';
import Portuguese from '../translations/po';
import Hindi from '../translations/hi';
import Arabic from '../translations/ar';

export const dictionaryList = {
	English,
	Chinese,
	Japanese,
	Korean,
	German,
	French,
	Spanish,
	Italian,
	Russian,
	Portuguese,
	Hindi,
	Arabic
};

class Home extends Component{
	constructor(props){
		super(props);		

		this.state = {
			showAddAssetPopup: false,
			showAddCharacterPopup: false,
			isLogin: false,
			dataLanguage: dictionaryList['English'],
			topAssetList: [],
			topAssetMonthList: [],
			topAssetTrendingList: [],
			topCharacterList: [],
			topCharacterAllTimeList: [],
			topCharacterThisMonthList: [],
			topPosterList: [],
			topPosterAllTimeList: [],
			topPosterThisMonthList: [],
			redirect: null,
			sortAssetOrder: 0,
			toCurrency: null,
			orgCurrencyList: [],
			userAvatarList: {},
			characterTitle: '',
			posterTitle: '',
			gameList: [],
			loadAssets: true			
		}

		if ( localStorage.getItem('Language') ) {
			this.state = {
				dataLanguage: dictionaryList[localStorage.getItem('Language')]
			};
		} else {
			this.state = {
				dataLanguage: dictionaryList['English']
			};
		}

		this.checkLogin = this.checkLogin.bind(this);
		this.getGameList = this.getGameList.bind(this);
		this.getTopAssets = this.getTopAssets.bind(this);
		this.getTopCharacters = this.getTopCharacters.bind(this);
		this.getTopUsers = this.getTopUsers.bind(this);
		this.drawTopCharacters = this.drawTopCharacters.bind(this);
		this.drawTopPosters = this.drawTopPosters.bind(this);
		this.drawTopAssets = this.drawTopAssets.bind(this);
	}

	componentDidMount(){
		this.getGameList();
		this.getCurrencyList();
		this.getTopCharacters(0);
		this.getTopUsers(0);
	}

	getCurrencyList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getCurrencyList')
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						orgCurrencyList: response.data
					});

					this.getTargetCurrency();
					this.getTopAssets(0);
				}
			})
	}

	getGameList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getGameList')
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						gameList: response.data
					})
				}
			})
	}

	getTargetCurrency() {
		var filteredOptions = [];
		if ( localStorage.getItem('countryId') ) {
			filteredOptions = this.state.orgCurrencyList.filter(
				(currency) =>
				currency.countryId == localStorage.getItem('countryId')
			);

			if (filteredOptions.length == 0) {
				filteredOptions = this.state.orgCurrencyList.filter(
					(currency) =>
					currency.status == 2
				);
			}
		}

		if (filteredOptions.length) {
			this.setState({
				toCurrency: filteredOptions[0]
			})
		} else {
			this.setState({
				toCurrency: null
			})
		}
	}

	getTopUsers(val) {
		this.setState({
			topUsers: null
		});

		if (val == 1 && this.state.topPosterThisMonthList) {
			this.setState({
				topPosterList: this.state.topPosterThisMonthList
			}, function(){
				this.drawTopPosters();
			})
		} else if (val != 1 && this.state.topPosterAllTimeList) {
			this.setState({
				topPosterList: this.state.topPosterAllTimeList
			}, function(){
				this.drawTopPosters();
			})
		} else {
			axios.defaults.withCredentials = true;
			
			axios.get(window.$backend_url + '/getTopUserList?max_count=24&type=' + val)
				.then(response => {
					if ( response.status === 200 ) {
						for (var i=0; i<response.data.length; i++) {
							response.data[i].avatarImage = '/assets/images/loading.gif';
						}

						this.setState({
							topPosterList: response.data
						})

						// this.drawTopPosters();

						if (this.state.loadAssets) {
							var loadCount = response.data.length;
							var loadedUserCount = 0;
							for (i=0; i<response.data.length; i++) {
								const data = {
									userid: response.data[i].id
								}

								let currentIndex = i;

								axios.post(window.$backend_url + '/getUserAvatar', data)
									.then(response => {
										let temp = this.state.topPosterList;

										if ( response.status === 200 ) {
											temp[currentIndex].avatarImage = response.data;
										} else {
											temp[currentIndex].avatarImage = 'assets/images/profile-img.png';
										}

										this.setState({
											topPosterList: temp
										})

										if (val == 1) {
											this.setState({
												topPosterThisMonthList: temp
											})
										} else {
											this.setState({
												topPosterAllTimeList: temp
											})
										}

										loadedUserCount++;

										if (loadedUserCount == this.state.topPosterList.length) {
											this.drawTopPosters();
										}
									})
									.catch(error => {
										let temp = this.state.topPosterList;
										temp[currentIndex].avatarImage = 'assets/images/profile-img.png';
										this.setState({
											topPosterList: temp
										})

										if (val == 1) {
											this.setState({
												topPosterThisMonthList: temp
											})
										} else {
											this.setState({
												topPosterAllTimeList: temp
											})
										}
									
										loadedUserCount++;

										if (loadedUserCount == this.state.topPosterList.length) {
											this.drawTopPosters();
										}
									})
							}
						}
					}
				})
		}
	}

	drawTopPosters() {
		let slider = this.state.topPosterList.map((user, index) => {
			let userBackStyle = {
				backgroundImage:  "url('" + user.avatarImage + "')"
			};

			return(
				<div key={index} className="tbl_row">
					<div className="tbl_column list-no">{index+1}.</div>
					<div className="tbl_column live" onClick={this.goProfilePage.bind(this)}><div className="img_character" style={userBackStyle} rel={user.id}></div>
					<span className="online active"></span></div>
					<div className="tbl_column userName" onClick={this.goProfilePage.bind(this)} rel={user.id}>{user.first_name} {user.last_name}</div>
					<div className="tbl_column post">Posts <span>{user.postCount}</span></div>
					<div className="tbl_column right"><img alt="" src="/assets/images/flags/flag_english.png" /></div></div>
			)
		});

		this.setState({
			topUsers: slider
		});
	}

	goProfilePage(e) {
		if (e.target.getAttribute('rel')) {
			localStorage.setItem('userId', e.target.getAttribute('rel'));
			// this.setState({ redirect: "/profile" });
			this.props.history.push('/profile');
		}
	}

	getTopAssets(val) {
		this.setState({
			loadAssets: true
		})

		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getTopAssetList?max_count=24&type=' + val)
			.then(response => {
				if ( response.status === 200 ) {
					for (var i=0; i<response.data.length; i++) {
						response.data[i].assetImage = '/assets/images/loading.gif';
						response.data[i].avatar = '/assets/images/loading.gif';
					}

					switch (parseInt(val)) {
						case 1:
							this.setState({
								topAssetMonthList: response.data
							}, function(){
								this.drawTopAssets();
							})
							break;
						case 2:
							this.setState({
								topAssetTrendingList: response.data
							}, function(){
								this.drawTopAssets();
							})
							break;
						default:
							this.setState({
								topAssetList: response.data
							}, function(){
								this.drawTopAssets();
							})							
					}

					var loadCount = response.data.length;
					var loadCount2 = response.data.length;
					for (i=0; i<response.data.length; i++) {
						const data = {
							userId: response.data[i].userId,
							gameId: response.data[i].gameId,
							assetId: response.data[i].id
						}

						let currentIndex = i;

						axios.post(window.$backend_url + '/getAssetMainImage', data)
							.then(response => {
								if ( response.status === 200 ) {
									var temp;
									switch (parseInt(val)) {
										case 1:
											temp = this.state.topAssetMonthList;
											temp[currentIndex].assetImage = response.data;
											this.setState({
												topAssetMonthList: temp
											})
											break;
										case 2:
											temp = this.state.topAssetTrendingList;
											temp[currentIndex].assetImage = response.data;
											this.setState({
												topAssetTrendingList: temp
											})
											break;
										default:
											temp = this.state.topAssetList;
											temp[currentIndex].assetImage = response.data;
											this.setState({
												topAssetList: temp
											})
									}

									loadCount--;
									if (loadCount == 0) {
										this.drawTopAssets();
									}
								}
							})
							.catch(error => {
								var temp;
								switch (parseInt(val)) {
									case 1:
										temp = this.state.topAssetMonthList;
										temp[currentIndex].assetImage = 'assets/images/popular-game-main.jpg';
										this.setState({
											topAssetMonthList: temp
										})
										break;
									case 2:
										temp = this.state.topAssetTrendingList;
										temp[currentIndex].assetImage = 'assets/images/popular-game-main.jpg';
										this.setState({
											topAssetTrendingList: temp
										})
										break;
									default:
										temp = this.state.topAssetList;
										temp[currentIndex].assetImage = 'assets/images/popular-game-main.jpg';
										this.setState({
											topAssetList: temp
										})
								}

								loadCount--;
								if (loadCount == 0) {
									this.drawTopAssets();
								}
							})
					
						const data2 = {
							userid: response.data[i].userId
						}

						axios.post(window.$backend_url + '/getUserAvatar', data2)
							.then(response => {
								if ( response.status === 200 ) {
									var temp;
									switch (parseInt(val)) {
										case 1:
											temp = this.state.topAssetMonthList;
											temp[currentIndex].avatar = response.data;
											this.setState({
												topAssetMonthList: temp
											})
											break;
										case 2:
											temp = this.state.topAssetTrendingList;
											temp[currentIndex].avatar = response.data;
											this.setState({
												topAssetTrendingList: temp
											})
											break;
										default:
											temp = this.state.topAssetList;
											temp[currentIndex].avatar = response.data;
											this.setState({
												topAssetList: temp
											})
									}

									loadCount2--;
									if (loadCount2 == 0) {
										this.drawTopAssets();
									}
								}
							})
							.catch(error => {
								var temp;
								switch (parseInt(val)) {
									case 1:
										temp = this.state.topAssetMonthList;
										temp[currentIndex].avatar = 'assets/images/profile-img.png';
										this.setState({
											topAssetMonthList: temp
										})
										break;
									case 2:
										temp = this.state.topAssetTrendingList;
										temp[currentIndex].avatar = 'assets/images/profile-img.png';
										this.setState({
											topAssetTrendingList: temp
										})
										break;
									default:
										temp = this.state.topAssetList;
										temp[currentIndex].avatar = 'assets/images/profile-img.png';
										this.setState({
											topAssetList: temp
										})										
								}

								loadCount2--;
								if (loadCount2 == 0) {
									this.drawTopAssets();
								}
							})
					}
					
					
				}
			})
	}

	drawTopAssets() {
		var currentList = this.state.topAssetList;
		if (this.state.sortAssetOrder == 1) {
			currentList = this.state.topAssetMonthList;
		} if (this.state.sortAssetOrder == 2) {
			currentList = this.state.topAssetTrendingList;
		}
		
		let slider = currentList.map((asset, index) => {
			let assetBackStyle = {
				backgroundImage:  "url('" + asset.assetImage + "')"
			};

			let backStyle = {
				backgroundImage:  "url('" + asset.avatar + "')"
			};

			var symbol = '$';
			var price = asset.price;

			if (this.state.toCurrency) {
				symbol = this.state.toCurrency.symbol;
				price = parseFloat((parseFloat(price) * parseFloat(this.state.toCurrency.rate)).toFixed(2));
			}

			return(
				<div key={index} className="item">
					<div className="assetImage" style={assetBackStyle}></div>
					<div className="details">
						<div className="profile-img" style={backStyle} onClick={this.goProfilePage.bind(this)} rel={asset.userId}></div>
						<div className="profile-details">
							<p className="userName" onClick={this.goProfilePage.bind(this)} rel={asset.userId}>{asset.first_name} {asset.last_name}</p>
							<p><span>{this.state.dataLanguage['item_name']}:</span> {asset.name}</p>
							<p><span>{this.state.dataLanguage['game']}:</span> {asset.gameName}</p>
						</div>
						<div className="profile-likes">
							<p><img onClick={this.goAssetDescription.bind(this)} rel={index} alt="" src="/assets/images/icons/like-icon.png" />{asset.likeCount}</p>
							<p><img onClick={this.goAssetDescription.bind(this)} rel={index} alt="" src="/assets/images/icons/dislike-icon.png" />{asset.dislikeCount}</p>
						</div>
						<div className="profile-view">
							<p>{symbol}{price}</p>
							<p><a className="view-item" href="" onClick={this.goAssetDescription.bind(this)} rel={index}>{this.state.dataLanguage['view_item']}</a></p>
						</div>
					</div>
				</div>
			)
		});

		this.setState({
			topAssetSlides: slider
		});
	}

	getTopCharacters(val) {
		this.setState({
			loadAssets: true
		});

		var characterTitle = this.state.dataLanguage['all_time_characters'];
		var posterTitle = this.state.dataLanguage['all_time_posters'];

		if (val == 1) {
			characterTitle = this.state.dataLanguage['this_month_characters'];
			posterTitle = this.state.dataLanguage['this_month_posters'];
		} else if (val == 2) {
			characterTitle = this.state.dataLanguage['trending_characters'];
			posterTitle = this.state.dataLanguage['trending_posters'];
		}

		this.setState({
			topCharacters: null,
			characterTitle: characterTitle,
			posterTitle: posterTitle
		});
		
		if (val != 1 && this.state.topCharacterAllTimeList) {
			this.setState({
				topCharacterList: this.state.topCharacterAllTimeList
			}, function(){
				this.drawTopCharacters();
			})
		} else if (val == 1 && this.state.topCharacterThisMonthList) {
			this.setState({
				topCharacterList: this.state.topCharacterThisMonthList
			}, function(){
				this.drawTopCharacters();
			})
		} else {
			axios.defaults.withCredentials = true;
		
			axios.get(window.$backend_url + '/getTopCharacterList?max_count=24&type=' + val)
				.then(response => {
					if ( response.status === 200 ) {
						for (var i=0; i<response.data.length; i++) {
							if (response.data[i].mainImageUrl) {
								response.data[i].mainImage = response.data[i].mainImageUrl;							
							} else {
								response.data[i].mainImage = '/assets/images/loading.gif';
							}
						}

						this.setState({
							topCharacterList: response.data
						})

						this.drawTopCharacters();

						if (this.state.loadAssets) {
							var loadCount = this.state.topCharacterList.length;
							var loadedCharacterCount = 0;
							for (i=0; i<this.state.topCharacterList.length; i++) {
								if ( this.state.topCharacterList[i].mainImageUrl ) {
									loadedCharacterCount++;
								} else {
									const data = {
										userId: this.state.topCharacterList[i].userId,
										gameId: this.state.topCharacterList[i].gameId,
										characterId: this.state.topCharacterList[i].id
									}

									let currentIndex = i;

									axios.post(window.$backend_url + '/getCharacterMainImage', data)
										.then(response => {
											if ( response.status === 200 ) {
												let temp = this.state.topCharacterList;
												temp[currentIndex].mainImage = response.data;
												this.setState({
													topCharacterList: temp
												})

												loadedCharacterCount++;

												if (loadedCharacterCount == this.state.topCharacterList.length) {
													this.drawTopCharacters();
												}

												if (val == 1) {
													this.setState({
														topCharacterThisMonthList: temp
													})
												} else {
													this.setState({
														topCharacterAllTimeList: temp
													})
												}
											}
										})
										.catch(error => {
											let temp = this.state.topCharacterList;											
											if (temp[currentIndex]) {
												temp[currentIndex].mainImage = 'assets/images/popular-game-main.jpg';
											}
											
											this.setState({
												topCharacterList: temp
											})

											loadedCharacterCount++;

											if (loadedCharacterCount == this.state.topCharacterList.length) {
												this.drawTopCharacters();
											}

											if (val == 1) {
													this.setState({
														topCharacterThisMonthList: temp
													})
												} else {
													this.setState({
														topCharacterAllTimeList: temp
													})
												}
										})
								}
							}
						}
					}
				})
				.catch(error => {
					console.log(error);
				})
		}
	}

	drawTopCharacters() {
		let slider = this.state.topCharacterList.map((character, index) => {
			let characterBackStyle = {
				backgroundImage:  "url('" + character.mainImage + "')"
			};

			var symbol = '$';
			var price = character.price;
			if (character.characterPrice) {
				price += character.characterPrice;
			}

			if (this.state.toCurrency) {
				symbol = this.state.toCurrency.symbol;
				price = parseFloat(price) * parseFloat(this.state.toCurrency.rate);
			}

			price = parseFloat(parseFloat(price).toFixed(2));

			return(
				<div key={index} className="tbl_row">
					<div className="tbl_column list-no">{index+1}.</div>
					<div className="tbl_column live" onClick={this.goCharacterDescription.bind(this)}><div className="img_character" style={characterBackStyle} rel={index} ></div>
					<span className="online active"></span></div>
					<div className="tbl_column characterName" onClick={this.goCharacterDescription.bind(this)} rel={index}>{character.name}</div>
					<div className="tbl_column aggregate">{symbol}{price}</div>
				</div>
			)
		});

		this.setState({
			topCharacters: slider
		});
	}

	goCharacterDescription(e) {
		if (e.target.getAttribute('rel')) {
			var index = e.target.getAttribute('rel');
			localStorage.setItem('characterId', this.state.topCharacterList[index].id);
			localStorage.setItem('characterImage', this.state.topCharacterList[index].mainImage);
			// this.setState({ redirect: "/characterDescription" });
			this.props.history.push('/characterDescription');
		}
	}

	goAssetDescription(e) {
		if (e.target.getAttribute('rel')) {
			localStorage.setItem('assetId', this.state.topAssetList[e.target.getAttribute('rel')].id);
			localStorage.setItem('assetImage', this.state.topAssetList[e.target.getAttribute('rel')].assetImage);
			localStorage.setItem('assetOwnerId', this.state.topAssetList[e.target.getAttribute('rel')].userId);
			localStorage.setItem('assetOwnerName', this.state.topAssetList[e.target.getAttribute('rel')].first_name + ' ' + this.state.topAssetList[e.target.getAttribute('rel')].last_name);
			localStorage.setItem('assetOwnerAvatar', this.state.topAssetList[e.target.getAttribute('rel')].avatar);
			// this.setState({ redirect: "/assetDescription" });
			this.props.history.push('/assetDescription');
		}
	}

	setLanguage(lang) {
		this.setState({
			dataLanguage: dictionaryList[lang]
		}, function(){
			this.drawTopAssets();
			this.getTopCharacters(this.state.sortAssetOrder);
			this.getTopUsers(this.state.sortAssetOrder);
		})
	}

	toggleAddAssetPopup() {
		if (cookie.load('cookieId')) {
			this.setState({  
				showAddAssetPopup: !this.state.showAddAssetPopup
			});
		} else {
			this.setState({  
				showAddAssetPopup: false
			});

			this.refs.header.toggleSignupPopup();
		}
	}

	toggleAddCharacterPopup() {
		if (cookie.load('cookieId')) {
			this.setState({  
				showAddCharacterPopup: !this.state.showAddCharacterPopup  
			});
		} else {
			this.setState({  
				showAddCharacterPopup: false
			});

			this.refs.header.toggleSignupPopup();
		}
	}

	checkLogin() {
		if (this.state.topAssetTrendingList) {
			this.getTargetCurrency();
			this.drawTopAssets();
			this.drawTopCharacters();
		}

		if (cookie.load('cookieId')) {
			this.setState({
				isLogin: true
			})
		} else {
			this.setState({
				isLogin: false
			})
		}
	}

	sortAsset = (e) => {
		var orderNum = e.target.getAttribute('rel');
		
		this.setState({
			sortAssetOrder: orderNum,
			topAssetSlides: null
		}, function(){
			switch (parseInt(orderNum)) {
				case 1:
					if (this.state.topAssetMonthList == undefined) {
						this.getTopAssets(orderNum);
					} else {
						this.drawTopAssets();
					}
					break;
				case 2:
					if (this.state.topAssetTrendingList == undefined) {
						this.getTopAssets(orderNum);
					} else {
						this.drawTopAssets();
					}
					break;
				default:
					if (this.state.topAssetList == undefined) {
						this.getTopAssets(orderNum);
					} else {
						this.drawTopAssets();
					}
			}
		})

		this.getTopCharacters(orderNum);
		this.getTopUsers(orderNum);
	}

	render(){
		if (this.state.redirect) {
			return <Redirect to={this.state.redirect} />
		}

		const sliderOption = {
				loop: false,
				margin: 10,
				nav:true,
				responsive:{
					0: {
						items: 1,
						nav: false,
					},
					600: {
						items: 3,
					},
					1000: {
						items: 4,
					},
				}
			};

		return(
			<div className="digit home">
				<Header history={this.props.history} ref="header" dataLanguage={this.state.dataLanguage} setLanguage={this.setLanguage.bind(this)} checkLogin={this.checkLogin.bind(this)} toggleAddAssetPopup={this.toggleAddAssetPopup.bind(this)} />
				<div>
					<section className="banner">
						<div className="container">
							<Navigation active="1" dataLanguage={this.state.dataLanguage} history={this.props.history} header={this.refs.header} />
							
							<div className="banner-slider">
								<div className="owl-slider">
									<OwlCarousel items={1} className="owl-theme" loop autoplay>
										<div>
											<img alt="" className="img" src= {'assets/images/popular-game-main.jpg'}/>
										</div>
										<div className="slider-text">
											<p className="text-yellow">
												Welcome to DigitXchange, a community-driven website that alms to finally put a value on the worth of digital goods and services via crowd-sourcing. With your help, we can not only put a true value on the characters and assets you've spent painstaking hours cultivating, but we can also create the world's largest translation table between games!
												<br /><br />
												Assets you can value: currency, weapons, armor, mounts, collectibles, gacha characters, skins and more.
												<br /><br />
												We do have some minimal advertising to defray our operating costs but we also offer cheap monthly and annual subscriptions that not only help support this project but also remove advertisements and allow you the ability to create and value unlimited characters in your profile.
												<br /><br />
												For now, bear with us as we likely experience some early growing pains and bugs, and please don't hesitate to provide feedback so we can continue to tailor and improve the experience for everyone.
												<br /><br />
												Thank you for participating. We look forward to building a game-changing platform together.
												<br /><br />
												- The DigitX Team
											</p>
										</div>
									</OwlCarousel>
								</div>
							</div>
						</div>
					</section>
					
					<div className="main-area">
						<div className="container">
							<div className="post-create">
								<button onClick={this.toggleAddAssetPopup.bind(this)}>{this.state.dataLanguage['post']} <br /> {this.state.dataLanguage['asset']}</button>
								<button onClick={this.toggleAddCharacterPopup.bind(this)}>{this.state.dataLanguage['create']} <br /> {this.state.dataLanguage['character']}</button>
							</div>
							<div className="page-buttons">
								<ul>
									<li><a href="/assets">{this.state.dataLanguage['assets']}</a></li>
									<li><a href="/profile">{this.state.dataLanguage['profile']}</a></li>
								</ul>
								<ul>
									<li><a href="/games">{this.state.dataLanguage['games']}</a></li>
									<li><a href="/currency">{this.state.dataLanguage['currency']}</a></li>
								</ul>
								<ul>
									<li>
										<a href="/store">{this.state.dataLanguage['store']}</a>
									</li>
								</ul>
							</div>

							<div className="tab">
								<ul>
									<li className={this.state.sortAssetOrder == 0 || !this.state.sortAssetOrder ? "clicked" : ''} onClick={this.sortAsset} rel="0">{this.state.dataLanguage['all_time']}</li>
									<li className={this.state.sortAssetOrder == 1 ? "clicked" : ''} onClick={this.sortAsset} rel="1">{this.state.dataLanguage['this_month']}</li>
									<li className={this.state.sortAssetOrder == 2 ? "clicked" : ''} onClick={this.sortAsset} rel="2">{this.state.dataLanguage['trending']}</li>
								</ul>
							</div>
							
							<div className="game-slider">
								{this.state.topAssetSlides ?
									<div className="owl-slider">
										<OwlCarousel className="owl-theme" {...sliderOption} >
											{this.state.topAssetSlides}
										</OwlCarousel>
									</div>
								: null }
							</div>
							
							<div className="xch-leader">
								<div className="heading"><h2>Xchange {this.state.dataLanguage['leaderboard']}</h2></div>
								<div className="table-wrap">
									<div className="left-tbl">
										<h3>{this.state.characterTitle}</h3>
										{ this.state.topCharacters ?
											<div>
												{this.state.topCharacters}
											</div>
										: null}

									</div>
									<div className="right-tbl trending_posters">
										<h3>{this.state.posterTitle}</h3>
										{ this.state.topUsers ?
											<div>
												{this.state.topUsers}
											</div>
										: null}
									</div>
								</div>
							</div>							
						</div>
					</div>					
				</div>
				<Footer dataLanguage={this.state.dataLanguage} header={this.refs.header} />
				{this.state.showAddAssetPopup ?  
					<Modal show={this.state.showAddAssetPopup} onHide={this.toggleAddAssetPopup.bind(this)} animation={false} className="largeModal">
						<Modal.Header closeButton>
						</Modal.Header>
						<AddAsset history={this.props.history} dataLanguage={this.state.dataLanguage} closeAddAssetPopup={this.toggleAddAssetPopup.bind(this)} gameList={this.state.gameList} />
					</Modal>
				: null  
				}
				{this.state.showAddCharacterPopup ?  
					<Modal show={this.state.showAddCharacterPopup} onHide={this.toggleAddCharacterPopup.bind(this)} animation={false} className="largeModal">
						<Modal.Header closeButton>
						</Modal.Header>
						<AddCharacter history={this.props.history} dataLanguage={this.state.dataLanguage} closeAddCharacterPopup={this.toggleAddCharacterPopup.bind(this)} gameList={this.state.gameList} />
					</Modal>
				: null  
				}
			</div>
		)
	}
}
//export Home Component
export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.js